import { API } from "../api/axios";
const END_POINT = "/services";
const END_POINT_SERVICE = "/service";
const END_POINT_SERVICE_PRICE = "/serviceprice";
const END_POINT_SERVICE_STATUS = "/service-activation";
class ServicesService {
    getAll(params) {
        return API.get(END_POINT, params);
    }
    getAllActive(params) {
        return API.get(END_POINT, params);
    }
    get(id) {
        return API.get(`${END_POINT_SERVICE}/${id}`);
    }
    getPrice(id) {
        return API.get(`${END_POINT_SERVICE_PRICE}/${id}`);
    }
    createPrice(data,id) {
        return API.post(`${END_POINT_SERVICE_PRICE}/${id}`, data);
    }
    create(data,id) {
        return API.post(END_POINT_SERVICE, data);
    }
    updatePrice(id, data) {
        return API.post(`${END_POINT_SERVICE_PRICE}/${id}`, data);
    }
    update(id, data) {
        return API.post(`${END_POINT_SERVICE}/${id}`, data);
    }
    updateStatus(id) {
        return API.post(`${END_POINT_SERVICE_STATUS}/${id}`);
    }
}

export default new ServicesService();
